"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KEYCODE_TO_DIR = exports.Direction = void 0;
var Direction;
(function (Direction) {
    Direction["UP"] = "UP";
    Direction["DOWN"] = "DOWN";
    Direction["LEFT"] = "LEFT";
    Direction["RIGHT"] = "RIGHT";
})(Direction || (Direction = {}));
exports.Direction = Direction;
const KEYCODE_TO_DIR = new Map([
    [37, Direction.LEFT],
    [38, Direction.UP],
    [39, Direction.RIGHT],
    [40, Direction.DOWN],
]);
exports.KEYCODE_TO_DIR = KEYCODE_TO_DIR;
//# sourceMappingURL=Direction.js.map